export type CsvCell = string | number;

/**
 * A leading =, +, - or @ makes a spreadsheet treat the cell as a formula. CUR text
 * is attacker-influenced (tag values, resource names), so string cells get an
 * apostrophe guard. Numbers are left alone or they would stop being numbers.
 */
function guard(cell: CsvCell): string {
  if (typeof cell === "number")
    return Number.isFinite(cell) ? String(cell) : "";
  return /^[=+\-@\t\r]/.test(cell) ? `'${cell}` : cell;
}

function escape(cell: CsvCell): string {
  const value = guard(cell);
  return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function toCsv(headers: string[], rows: CsvCell[][]): string {
  return [headers, ...rows]
    .map((row) => row.map(escape).join(","))
    .join("\r\n");
}

/** Excel decodes a UTF-8 CSV as the local codepage unless it opens with a BOM. */
const byteOrderMark = String.fromCharCode(0xfeff);

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([byteOrderMark + csv], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
